<video id="video_{{idx}}" class="video-js vjs-default-skin" playsinline></video>


<!-- <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-control-label" for="title">Title</label>
                            <input type="text" name="title" class="form-control" [(ngModel)]="mediatitle"
                                required="required">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
<div class="modal fade" id="entertitle" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Delete Lesson</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- <div class="row forms"> -->
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="col-md-12"> -->
                                <div class="form-group">
                                    <label class="form-control-label" for="title">Title <span class="requiredfield">*</span></label>
                                    <input type="text" name="title" class="form-control" [(ngModel)]="mediatitle"
                                        required="required">
                                </div>
                                <!-- </div> -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <button type="submit" class="btn btn-danger text-uppercase mx-2"
                                    (click)="uploadclicked()">Upload</button>
                                <button type="button" class="btn btn-default text-uppercase "
                                    data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>